<template>
  <!-- eslint-disable vue/max-attributes-per-line vue/no-static-inline-styles -->
  <section class="summary-loader">
    <div>
      <div class="card wavebg card-header !tw-flex !tw-justify-between pt-16 pb-16">
        <div class="header-left tw-flex mobile:tw-w-full">
          <div class="empty-select mr-8">
            Not Specified
          </div>
          <button
            class="btn btn-outline-primary btn-sm btn-refresh"
            style="width:60px"
          >
            Filter
          </button>
        </div>
        <div class="tw-flex mobile:tw-w-full">
          <button
            class="btn btn-outline-primary btn-sm mr-8 pl-4 pr-4"
            style="width: 34px"
          >
            X
          </button>
          <button
            class="btn btn-outline-primary btn-sm btn-refresh"
            style="width: 79px"
          >
            Refresh
          </button>
        </div>
      </div>

      <div class="row summary-tables tw-pl-1rem mt-24">
        <div class="col-12 col-md-6 pl-0 pr-16">
          <div class="card wavebg mb-24">
            <h5>General</h5>
            <table class="table table-full-width">
              <tbody>
                <tr>
                  <td class>
                    Impressions
                  </td>
                  <td>1</td>
                </tr>
                <tr>
                  <td class>
                    Visits
                  </td>
                  <td>3</td>
                </tr>
                <tr>
                  <td>Visits / Impressions</td>
                  <td>3</td>
                </tr>
                <tr>
                  <td class>
                    Profit
                  </td>
                  <td>3</td>
                </tr>
                <tr>
                  <td class>
                    Revenue
                  </td>
                  <td>3</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="card wavebg mb-24">
            <h5>Registrations</h5>
            <table class="table table-full-width">
              <tbody>
                <tr>
                  <td>Visits / Impressions</td>
                  <td>3</td>
                </tr>
                <tr>
                  <td class>
                    Profit
                  </td>
                  <td>3</td>
                </tr>
                <tr>
                  <td class>
                    Revenue
                  </td>
                  <td>3</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="card wavebg mb-24">
            <h5>Deposits</h5>
            <table class="table table-full-width">
              <tbody>
                <tr>
                  <td>Visits / Impressions</td>
                  <td>3</td>
                </tr>
                <tr>
                  <td class>
                    Profit
                  </td>
                  <td>3</td>
                </tr>
                <tr>
                  <td class>
                    Revenue
                  </td>
                  <td>3</td>
                </tr>
                <tr>
                  <td>Visits / Impressions</td>
                  <td>3</td>
                </tr>
                <tr>
                  <td class>
                    Profit
                  </td>
                  <td>3</td>
                </tr>
                <tr>
                  <td class>
                    Revenue
                  </td>
                  <td>3</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="card wavebg col-12 col-md-6 mb-24">
          <h5>Bets</h5>
          <table class="table table-full-width">
            <tbody>
              <tr>
                <td>Visits / Impressions</td>
                <td>3</td>
              </tr>
              <tr>
                <td class>
                  Profit
                </td>
                <td>3</td>
              </tr>
              <tr>
                <td class>
                  Revenue
                </td>
                <td>3</td>
              </tr>
              <tr>
                <td>Visits / Impressions</td>
                <td>3</td>
              </tr>
              <tr>
                <td class>
                  Profit
                </td>
                <td>3</td>
              </tr>
              <tr>
                <td class>
                  Revenue
                </td>
                <td>3</td>
              </tr>
              <tr>
                <td>Visits / Impressions</td>
                <td>3</td>
              </tr>
              <tr>
                <td class>
                  Profit
                </td>
                <td>3</td>
              </tr>
              <tr>
                <td class>
                  Revenue
                </td>
                <td>3</td>
              </tr>
              <tr>
                <td>Visits / Impressions</td>
                <td>3</td>
              </tr>
              <tr>
                <td class>
                  Profit
                </td>
                <td>3</td>
              </tr>
              <tr>
                <td class>
                  Revenue
                </td>
                <td>3</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss">
// @import 'src/assets/theme/default/components/styles-loaders';

</style>
